import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import styled from 'styled-components';
import { pxToRems } from '@awaze/design-system.utils.react';
import { DisclosureItemContext } from './disclosureItem.context';
import { Chevron } from './icon';
export const DisclosureToggle = ({ children, onClick, showIcon = true, ...rest }) => {
    const { toggleOpen, open } = useContext(DisclosureItemContext);
    const keyDown = (event) => {
        if (event.key && (event.key == 'Enter' || event.key == ' ')) {
            toggleOpen();
        }
    };
    return (_jsxs(DisclosureToggleStyled, { ...rest, tabIndex: 0, role: "button", "aria-expanded": open ? 'true' : 'false', onClick: onClick || toggleOpen, onKeyDown: (e) => keyDown(e), open: open, children: [_jsx(TitleStyled, { children: children }), showIcon && (_jsx(CloseButtonStyled, { children: _jsx(Chevron, {}) }))] }));
};
const TitleStyled = styled.span `
  user-select: none;
`;
const CloseButtonStyled = styled.span `
  height: ${({ theme }) => pxToRems(theme.FontTextText400LineHeight)};
  width: ${({ theme }) => pxToRems(theme.FontTextText400LineHeight)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 0 ${({ theme }) => pxToRems(theme.FontTextText400LineHeight)};

  > svg {
    fill: currentColor;
    width: 16px;
  }
`;
const DisclosureToggleStyled = styled.div `
  font-size: ${({ theme }) => pxToRems(theme.FontTextText400MidFontSize)};
  line-height: ${({ theme }) => pxToRems(theme.FontTextText400LineHeight)};
  color: ${({ theme }) => theme.ColorThemeLink};
  cursor: pointer;
  width: auto;
  color: ${({ theme }) => theme.ColorThemeLink};
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  padding: 12px 0;

  &:focus-visible {
    outline: 0;
    box-shadow: 0 0 0 4px ${({ theme }) => theme.ColorGrey100};
  }

  ${CloseButtonStyled} {
    > svg {
      transform: rotate(${({ open }) => (open ? '0' : '-90')}deg);
    }
  }
`;
//# sourceMappingURL=disclosureToggle.js.map